<template>
  <div id="previewClass3" style="background: white" :style="previewClass3Style">
    <div id="Scroller">
      <TopMarquee :classtype="3" :issue="1"/>
      <div  id="ArticleCotainer">
        <div class="Article"
             v-for="(a,key) in allArticles" @click="viewArticle(a+1,1,1)" :key="key">
          <div class="ArticleImg">
            <img :src="require('../assets/1/'+(a+1)+'/cover.jpg')">
          </div>
          <div class="ArticleTitle">
            {{article(a).title}}
          </div>
          <div class="ArticleDate">
            {{article(a).date}}
          </div>
        </div>
      </div>
      <div id="endimg">
        <img src="../assets/end.png"/>
      </div>
    </div>
  </div>
</template>

<script>
import articlesStore_1 from "../store/articlesStore_1"
import pageStackStore from "../store/pageStackStore"
import store from "../store/"
import TopMarquee from "./MarqueePreview";

export default {
  name: "class3",
  components:{
    TopMarquee
  },
  data(){
    return {
      allMarquee:[
      ],
      allArticles:[
      ],
      thisMarquee:0,
      scrollerClass3:0
    }
  },
  mounted:function () {
    this.getArticles();
    var scrollerConfig = {
      '//Description' : 'Default scroller with no configuration',
      touchSpeed:1
    };
    this.scrollerClass3 = new Scroller('#previewClass3', scrollerConfig);
  },
  methods:{
    article(id){
      return articlesStore_1.state.articles[id];
    },
    getArticles:function () {
      let list=articlesStore_1.state['class3'].list
      this.allArticles=list
    },
    viewArticle:function(id,issue,thisclass){
      pageStackStore.commit('pushPageStack', this.$route.path)
      this.$router.replace({ name: 'Article',
        params: { id,issue,class:thisclass}})
    },
  },
  computed:{
    previewClass3Style(){
      return {
        // height:(window.innerHeight-111*window.innerWidth/1125)+'px'
        height:(store.state.WindowSize.WindowHeightRem-0.9-1.31-1.11-1.31)+'rem'
      }
    }
  }
}
</script>

<style lang="less" scoped>
@fullWidth:11.25rem;
.fullWidhth{
  width: @fullWidth;
}

#previewClass3{
  .fullWidhth();
  //overflow: visible;

  #Scroller{
    .fullWidhth();

    background: white;

    #ArticleCotainer{
      .fullWidhth();

      padding-left:.35rem;
      padding-right:.35rem;

      .Article{
        overflow: hidden;
        background: white;
        width:5.07rem;
        height:5.08rem;
        border-radius:.45rem;
        margin-left: .1rem;
        margin-right: .1rem;
        margin-top:.45rem;
        box-shadow: 0px 0px .15rem .01rem #cccccc;

        .ArticleImg{
          overflow: hidden;
          width: 100%;
          height:2.85rem;

          img{
            width: 100%
          }
        }

        .ArticleTitle{
          color: black;
          width:4.18rem;
          height:1.2rem;
          line-height:.5rem;
          margin-top: .2rem;
          margin-left: .45rem;
          font-size: .35rem;
        }

        .ArticleDate{
          color: #989898;
          width:4.3rem;
          height:.3rem;
          line-height:.3rem;
          margin-left: .45rem;
          margin-top: .25rem;
          font-size: .3rem;
        }
      }
    }
    #endimg{
      width: 2.58rem;
      margin-left: 4.335rem;
      margin-top: .6rem;
      margin-bottom: .9rem;

      img{
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/previewClass3.vue